@if (data$ | async; as data) {
  @if (visible | async) {
    <cx-generic-link
      [url]="data.urlLink"
      [target]="getTarget(data)"
      >
      @if (data.headline) {
        <p class="headline" [innerHTML]="data.headline"></p>
      }
      <cx-media [container]="data.media"></cx-media>
      @if (data.content) {
        <p class="content" [innerHTML]="data.content"></p>
      }
    </cx-generic-link>
  }
}
